import { useEffect } from "react";

type SeoProps = {
	title: string;
	description: string;
	path: string;
	serviceName?: string;
};

export function Seo({ title, description, path, serviceName }: SeoProps) {
	useEffect(() => {
		document.title = title;
		const canonicalUrl = `https://www.govaengineering.com${path}`;
		const setMeta = (selector: string, attribute: "name" | "property", key: string, content: string) => {
			let tag = document.head.querySelector<HTMLMetaElement>(selector);
			if (!tag) {
				tag = document.createElement("meta");
				tag.setAttribute(attribute, key);
				document.head.appendChild(tag);
			}
			tag.content = content;
		};
		setMeta('meta[name="description"]', "name", "description", description);
		setMeta('meta[property="og:title"]', "property", "og:title", title);
		setMeta('meta[property="og:description"]', "property", "og:description", description);
		setMeta('meta[property="og:url"]', "property", "og:url", canonicalUrl);
		setMeta('meta[property="og:type"]', "property", "og:type", "website");
		setMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
		setMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
		setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
		let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
		if (!canonical) {
			canonical = document.createElement("link");
			canonical.rel = "canonical";
			document.head.appendChild(canonical);
		}
		canonical.href = canonicalUrl;

		const schemaId = "page-structured-data";
		let schema = document.head.querySelector<HTMLScriptElement>(`#${schemaId}`);
		if (!schema) {
			schema = document.createElement("script");
			schema.id = schemaId;
			schema.type = "application/ld+json";
			document.head.appendChild(schema);
		}
		schema.text = JSON.stringify({
			"@context": "https://schema.org",
			"@type": serviceName ? "Service" : "WebPage",
			name: serviceName || title,
			description,
			url: canonicalUrl,
			...(serviceName
				? {
					provider: {
						"@type": "ProfessionalService",
						name: "Gova Engineering",
						url: "https://www.govaengineering.com/",
					},
					areaServed: ["Austin", "Travis County", "Bastrop County", "Caldwell County", "Hays County", "Williamson County"],
				  }
				: {}),
		});
	}, [title, description, path, serviceName]);

	return null;
}
